import React from "react";
import { Background } from "reactflow";
import { resolveGridStyle } from "../utils/mapThemes.js";

export default function ThemeGrid({ theme, gridMode, showGrid = true, color }) {
  const grid = resolveGridStyle(theme, gridMode, showGrid);
  if (grid.type === "none") return null;
  return (
    <Background
      gap={grid.spacing}
      size={grid.type === "cross" ? 6 : 1}
      color={color || theme.grid}
      variant={grid.type}
      style={{ opacity: grid.opacity }}
    />
  );
}
